import applySearchParams from "libs/applySearchParams";
import {RestRequestGET} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";
import reduxStore from "redux/store";
import {clearResource, setResource} from "redux/actions";

const AUDIT_ALLOWED_OBJECT_LIST_RESOURCE = "auditAllowedObjectList";

const get = async (page = 1, pageSize = 10, filters = {}, sort = {}) => {

    const {
        column,
        direction
    } = sort

    let params = {
        'page': page,
        'pageSize': pageSize
    }
    params = applySearchParams(filters, params);

    if (column) {
        params['sort[0].column'] = column
        params['sort[0].direction'] = direction.toUpperCase()
    }

    try {
        const res = await RestRequestGET(Endpoints.AUDIT_ALLOWED_OBJECT_LIST, {
            params
        });

        reduxStore.dispatch(
            setResource(AUDIT_ALLOWED_OBJECT_LIST_RESOURCE, res)
        )

        return res;
    } catch (error) {
    }
}

const clear = () => {
    reduxStore.dispatch(
        clearResource(AUDIT_ALLOWED_OBJECT_LIST_RESOURCE)
    )
}

export default {
    get,
    clear
}